import { DlfMatcherTypes } from "../../types/rules/DlfMatcherTypes";
import {
  AllowEmptyDlfMatcher,
  AllowEmptyDlfMatcherProperties,
} from "./AllowEmptyDlfMatcher";

type FuzzyFieldMatcherData = {
  fuzzyKey: string;
  threshold: number;
} & AllowEmptyDlfMatcherProperties;

class FuzzyFieldMatcher
  extends AllowEmptyDlfMatcher
  implements FuzzyFieldMatcherData
{
  static FUZZY_PRECISION: number = 4;

  allowEmpty: boolean;
  discriminator: DlfMatcherTypes = "F_FUZZY";
  /* Fuzzy Field Matcher properties */
  fuzzyKey: string;
  threshold: number;
  /* Dlf Matcher property */
  fieldName: string;
  /* Matcher properties */
  position: number;
  reusable: boolean;
  ocrConfidenceThreshold: number;
  constructor(data: FuzzyFieldMatcherData) {
    super();
    this.fieldName = data.fieldName;
    this.fuzzyKey = data.fuzzyKey ?? "";
    this.threshold = data.threshold;
    this.position = data.position;
    this.reusable = data.reusable ?? true;
    this.allowEmpty = data.allowEmpty ?? false;
    this.ocrConfidenceThreshold = data.ocrConfidenceThreshold;
  }
  isConfigured(): boolean {
    return this.fuzzyKey !== "";
  }
  clear(): void {
    this.fuzzyKey = "";
  }

  toMatcherData(): FuzzyFieldMatcherData {
    return {
      ocrConfidenceThreshold: this.ocrConfidenceThreshold,
      discriminator: this.discriminator,
      allowEmpty: this.allowEmpty,
      fieldName: this.fieldName,
      position: this.position,
      fuzzyKey: this.fuzzyKey,
      threshold: this.threshold,
      reusable: this.reusable,
    };
  }

  getDiscriminator(): DlfMatcherTypes {
    return this.discriminator;
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }
  toggleAllowEmpty(): boolean {
    this.setAllowEmpty(!this.getAllowEmpty());
    return this.getAllowEmpty();
  }
  setAllowEmpty(value: boolean): void {
    this.allowEmpty = value;
  }
  getAllowEmpty(): boolean {
    return this.allowEmpty;
  }

  getMatcherId(): string {
    return `${this.discriminator}-${this.fuzzyKey}-${this.threshold.toPrecision(FuzzyFieldMatcher.FUZZY_PRECISION)}-${this.ocrConfidenceThreshold}`;
  }

  static createTest(
    rest: Partial<FuzzyFieldMatcherData> = {},
  ): FuzzyFieldMatcher {
    const data: FuzzyFieldMatcherData = {
      ocrConfidenceThreshold: -1,
      fuzzyKey: "",
      threshold: 0,
      fieldName: "",
      allowEmpty: false,
      position: 0,
      reusable: true,
      discriminator: "F_FUZZY",
    };

    return new FuzzyFieldMatcher({
      ...data,
      ...rest,
    });
  }
}

export { FuzzyFieldMatcher, FuzzyFieldMatcherData };
